<template>
  <v-app>
    <v-app-bar app>
      <router-link to="/">
        <v-img
          alt="SafeSyte Logo"
          class="shrink"
          contain
          src="/safesytelogo.png"
          transition="scale-transition"
          max-width="200px"
        />
      </router-link>
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn text to="/app">
          <v-icon left>mdi-speedometer</v-icon>App
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-account-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link>
              <v-list-item-title>Aanmelden</v-list-item-title>
            </v-list-item>
            <v-list-item link to="settings" v-if="$route.meta.auth">
              <v-list-item-title>Instellingen</v-list-item-title>
            </v-list-item>
            <v-list-item link to="beheer" v-if="$route.meta.auth">
              <v-list-item-title>Systeem configuratie</v-list-item-title>
            </v-list-item>
            <v-list-item link to="login" v-if="$route.meta.auth">
              <v-list-item-title>Uitloggen</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer color="secondary" padless app>
      <v-row justify="center" no-gutters>
        <v-btn color="primary" text rounded class="my-2" to="/">Home</v-btn>
        <v-btn color="primary" text rounded class="my-2" to="/about" v-show="false">Over ons</v-btn>
        <v-btn color="primary" text rounded class="my-2" to="/contact">Contact</v-btn>
        <v-col class="primary py-4 text-center white--text" cols="12">
          &copy; {{ new Date().getFullYear() }} 
          <strong><a href="https://heidekracht.nl" target="_blank" class="white--text">Heidekracht</a></strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({}),
  methods: {
    gohome: function () {
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style scoped>
.logoname {
  cursor: pointer;
}
</style>

<style>
.v-application {
  font-family: "Open Sans", sans-serif !important;
}
</style>